<template>
    <div style="min-height: 750px;">
        <van-nav-bar style="position: sticky; top: 0"
        >
            <span slot="title" style="font-size: 18px">升级超级会员</span>
        </van-nav-bar>

        <div style="min-height: 200px; padding: 20px;">
            <h2>
                升级进展：<span :style="{color: step_text_color}">{{new_channel_name ? upgrade_steps : '获取微信群编号'}}</span>
<!--                <van-tag :type="tag_type" plain style="font-size: 16px; position: absolute;margin-top: -2px;"  >-->
<!--                    {{upgrade_steps}}-->
<!--                </van-tag>-->
            </h2>

            <div style="font-size: 15px">
                <div v-if="new_channel_name" style="margin-top: 20px">
                    为你分配微信群编号：{{new_channel_name}}
                </div>
                <div v-else style="margin-top: 20px">
                    为你分配微信群编号：
                    <van-button type="info" size="small" @click="clickToGetNewChannelName">点击获取群编号</van-button>
                </div>

                <div style="margin-top: 15px">
                    您需要完成如下操作完成升级
                </div>

                <div style="margin-top: 15px">
                    1，新拉或已有一个超过50人的微信推广群，群名称修改为"京东VIP内购群{{new_channel_name ? new_channel_name : '[微信群编号]'}}"
                </div>

                <div style="margin-top: 15px">
                    2，上传两张截图 <a @click="showExample">查看示例</a><br>
                    截图一：显示出群主和群人数<br>
                    截图二：显示出群名称
                    <van-image-preview
                            v-model="showPreview"
                            :images="images"
                    >
<!--                        <div slot="">第{{ index }}页</div>-->
                    </van-image-preview>
                </div>

                <div style="margin-top: 15px">
                    3，上传提交后，工作人员会在24小时内为您审核，审核结果请关注"会员"页面
                </div>
            </div>
        </div>

        <div style="background-color: #ffffff; padding: 15px; box-shadow: 1px 1px 5px #999999">
            <div style="font-size: 16px; margin-bottom: 10px">
                <van-row>
                    <van-col span="20">
<!--                        图片上传 <span v-if="upload_img_status" style="font-size: 13px; color: red">({{upload_img_status}})</span>-->
                        图片上传&nbsp;
                        <van-tag v-if="upload_img_status"
                                 :type="tag_type"
                                 style="font-size: 12px; position: absolute;margin-top: 1px">{{upload_img_status}}</van-tag>
                    </van-col>
                    <van-col span="4" style="text-align: right">
                        {{fileList.length}}/2
                    </van-col>
                </van-row>
            </div>

            <van-uploader v-model="fileList" :disabled="isDistable" :after-read="onRead" accept="image/*" :max-count="2">
            </van-uploader>
        </div>


        <div style="padding: 15px;">
            <van-button type="primary" size="large" :disabled="isDistable" @click="submitToExamine">提交审核</van-button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Wp_mini_upgrade",
        components: {},
        data() {
            return {
                // fileList: [
                //     { name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' },
                //     { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }
                // ],

                fileList:[],
                imgUrlListValue:[],
                // imgUrlListValue:["82771f00-57f6-40b2-b936-4e9c5ad4d950.png", "2be7d051-00d7-4fc9-9c36-6080bc2ca2f6.png"],

                new_channel_name: "",

                show_get_new_channel_name_button: false,

                upgrade_steps: "待上传截图",
                step_text_color: "",

                showPreview: false,
                images:[
                    "/images/example_1.png",
                    "/images/example_2.png",
                ],

                isDistable: false,
                upload_img_status: "",
                tag_type:"",
            };
        },

        created(){
            this.initChannelName();

            this.checkExamine();
        },

        methods: {

            /**
             * 查看示例
             */
            showExample(){
                this.showPreview = true;
            },

            /**
             * 查询提交审核的状态
             */
            checkExamine(){
                let params = {
                    phone: this.$common.gloabl_wx_mini_user_info.phone
                    // phone: "13810889527"
                };

                this.$checkExamine(params, response=>{
                    this.$log(response)
                    if(response && response.code === 200){
                        //flag:0待审核 1是已审核 2是未通过 3是不存在
                        // response.flag = 1;
                        if(response.flag === 0){
                            this.upgrade_steps = "审核中";
                            this.step_text_color = "#1989fa";
                            this.isDistable = true;
                            this.upload_img_status = "审核中，图片上传暂时禁用";
                            this.tag_type="primary";
                        }else if(response.flag === 1){
                            this.upgrade_steps = "审核通过";
                            this.step_text_color = "#07c160";
                            this.isDistable = true;
                            this.upload_img_status = "审核通过，无需再上传图片";
                            this.tag_type="success";
                        }else if(response.flag === 2){
                            this.upgrade_steps = "审核未通过";
                            this.step_text_color = "#ee0a24";
                            this.isDistable = false;
                            this.upload_img_status = "审核未通过，请按要求上传规范截图";
                            this.tag_type="danger";
                        }else if(response.flag === 3){
                            this.upgrade_steps = "待上传截图";
                            this.isDistable = false;
                            // this.upload_img_status = "请上传规范截图";
                            this.tag_type="default";
                        }
                    }
                })
            },

            /**
             * 提交审核
             */
            submitToExamine(){

                if(!this.new_channel_name){
                    this.$dialog.alert({
                        // message: "微信群编号生成中，请稍后"
                        message: "请先获取微信群编号"
                    });
                    return;
                }

                if(!this.imgUrlListValue || this.imgUrlListValue.length < 2){
                    this.$dialog.alert({
                        message: "请按要求上传两张截图"
                    });
                    return;
                }

                let params = this.$common.gloabl_wx_mini_user_info;

                if(!params.channel_name){
                    params.channel_name = this.new_channel_name;
                }
                params.upload_image = this.imgUrlListValue;

                if(params['user_name']){
                    params['user_name']=encodeURIComponent(params['user_name']);
                }

                if(params['nickname']){
                    params['nickname']=encodeURIComponent(params['nickname']);
                }

                // this.$log(this.imgUrlListValue)

                this.$submitToExamine(params, response =>{
                    this.$log(response)
                    // {msg: "用户W123456提交审核成功", code: 200}
                    if(response && response.code === 200){
                        //提交审核成功，发送消息到管理群
                        this.sendMessageToWechat();

                        this.$dialog.alert({
                            title: "成功",
                            message: response.msg,
                        }).then(()=>{
                            // this.$wx.miniProgram.navigateBack();
                            this.$common.navigateBack();
                        })
                    }else if(response && response.code > 200){
                        this.$dialog.alert({
                            title: "提示",
                            message: response.msg,
                        })
                    }else{
                        this.$dialog.alert({
                            title: "失败",
                            message: "提交审核异常，请检查图片等相关数据"
                        })
                    }
                })
            },

            /**
             * 注册成功后发送消息到指定微信群
             */
            sendMessageToWechat(){

                let _content = "[普通会员]升级申请：";

                if(this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.phone){
                    _content += "\n微信昵称：" + this.$common.gloabl_wx_mini_user_info.user_name;
                }

                _content += "\n会员编号：" + this.new_channel_name;

                if(this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.phone){
                    _content += "\n联系方式：" + this.$common.gloabl_wx_mini_user_info.phone;
                }

                _content += "\n请尽快进行审核";
                _content += "\n来源：万品京选小程序";

                let params = {
                    content: _content
                };

                this.$sendMessageToWechat_ByTs(params, response=>{
                    this.$log(response)
                })
            },

            /**
             * 初始化微信群编号
             */
            initChannelName(){
                // let openid = this.$common.gloabl_wx_mini_user_info.open_id;
                if(this.$common.gloabl_wx_mini_user_info){
                    // let id = this.$common.gloabl_wx_mini_user_info.id;
                    let channelName = this.$common.gloabl_wx_mini_user_info.channel_name;
                    // channelName = '';//测试
                    if(!channelName){
                        // this.clickToGetNewChannelName();
                        this.show_get_new_channel_name_button = true;
                    }else{
                        this.new_channel_name = channelName;
                        this.show_get_new_channel_name_button = false;
                    }
                }else{
                    this.$dialog.alert({
                        message: "数据异常，请返回重试"
                    }).then(()=>{
                        this.$router.back();
                    })
                }

            },

            /**
             * 通过点击获取新的微信群号
             */
            clickToGetNewChannelName(){
                // this.new_channel_name = 'S101'
                //生成群主编号
                // this.new_channel_name = this.$common.createChannelName();

                //从服务器获取新的群号
                this.getNewChannelName(response=>{
                    if(response.data){
                        this.new_channel_name = response.data;

                        //存储到临时缓存中的userInfo中
                        this.$common.gloabl_wx_mini_user_info.channel_name = this.new_channel_name;
                        let id = this.$common.gloabl_wx_mini_user_info.id;
                        let save_userinfo_params = {
                            id: id,
                            channel_name: this.new_channel_name,
                            channel_id: ""
                        };

                        //发送到服务器存储
                        this.$saveUserinfoToServer(save_userinfo_params, response=>{
                            this.$log(response)

                            this.$getGloabl_WxUserinfo(id, login_status=>{
                                if (login_status && login_status !== "none") {
                                    let userInfo = this.$common.gloabl_wx_mini_user_info;

                                    let user = this.$store.state;
                                    user.username = userInfo.channel_name;
                                    this.$store.commit('login', user);
                                }
                            })
                        });
                    }
                });
            },

            /**
             * 获取新的群编号
             */
            getNewChannelName(fn){
                this.$getNewChannelName(response=>{
                    this.$log(response)
                    if(response && response.code === 200){
                        if(fn){
                            fn(response)
                        }
                    }else{
                        if(response && response.message){
                            this.$dialog.alert({
                                message: response.message
                            })
                        }
                    }
                })
            },

            /**
             * 上传图片到图片服务器
             */
            onRead (file) {

                let fd = new FormData();
                fd.append('image', file.file);
                // fd.append('img', file.content);//base64

                let data = fd;
                // this.$log(data);
                // this.$log(fd.get('image'));

                this.$postImage(data, response=>{
                    this.$log(response)

                    if(response && response.code === 200){
                        this.$toast.success({
                            message: "图片上传成功",
                            duration: 1000
                        });
                        this.imgUrlListValue.push(response.data)
                    }else{
                        this.$toast.fail("图片上传失败");
                    }
                })

            },
        }
    }
</script>

<style scoped>

    .upload-img-5{
        margin: 5px 0 90px 0;
    }
    .upload-img-1{
        margin: 5px 0 15px 0;
    }

</style>